export const galleryButtonAutomationTypeSuffix = "GalleryButton";
